import {Pipe, PipeTransform} from '@angular/core';

interface ConsultantNameParts {
  vorname?: string;
  nachname?: string;
  name?: string;
}

/** Formatiert den Beraternamen als „Nachname, Vorname"; fällt auf das kombinierte name-Feld zurück. */
@Pipe({name: 'consultantName', standalone: true})
export class ConsultantNamePipe implements PipeTransform {
  transform(value: ConsultantNameParts | null | undefined): string {
    const nachname = value?.nachname?.trim();
    const vorname = value?.vorname?.trim();
    if (nachname && vorname) return `${nachname}, ${vorname}`;
    if (nachname) return nachname;
    if (vorname) return vorname;
    return value?.name?.trim() ?? '';
  }
}
